/**
 * @fileoverview Stable a11y ids shared by the sub-genre tablist and its panels.
 *
 * **This module must never carry a `'use client'` directive.** It is imported
 * by `CategoryHubTemplate`, which is a Server Component, and these helpers are
 * *called* during the server render to build `id` / `aria-labelledby` /
 * `aria-controls` attributes.
 *
 * They used to live in `SubGenreChips.tsx`, which is `'use client'`. Across the
 * RSC boundary a value exported from a client module resolves to a client
 * *reference*, not a function, so invoking one on the server throws:
 *
 *   Error: Attempted to call subGenrePanelId() from the server but
 *   subGenrePanelId is on the client.
 *
 * That surfaced as React error #441 ("An error occurred in the Server
 * Components render") and took out the whole `/category/[slug]` route via the
 * root error boundary — see WEB-801. Production was spared only because it had
 * no sub-genre data at the time, so the guarded `panelSlugs.map(...)` in
 * `CategoryHubTemplate` never executed.
 *
 * Keep pure, dependency-free id builders here. Anything needing React state,
 * effects, or event handlers belongs in `SubGenreChips.tsx` instead.
 *
 * @since WEB-801 (extracted from `SubGenreChips.tsx`)
 */

/** Stable tab control id — paired with `aria-labelledby` on the tabpanel. */
export function subGenreTabId(slug: string | null): string {
  return `subgenre-tab-${slug ?? 'all'}`;
}

/** Stable tabpanel id — paired with each chip's `aria-controls` (WEB-549). */
export function subGenrePanelId(slug: string | null): string {
  return `subgenre-panel-${slug ?? 'all'}`;
}
